module.exports = __webpack_public_path__ + "media/14.1d577b6b.mp3";